import { render } from "./ConfirmarEnvioDeDados.vue?vue&type=template&id=5834e9f6&scoped=true"
import script from "./ConfirmarEnvioDeDados.vue?vue&type=script&lang=js"
export * from "./ConfirmarEnvioDeDados.vue?vue&type=script&lang=js"

import "./ConfirmarEnvioDeDados.vue?vue&type=style&index=0&id=5834e9f6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5834e9f6"]])

export default __exports__